module.exports = __webpack_public_path__ + "img/ab-mobile-default.84afb5f5.png";